/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type OpenWebviewActionBhActionType =
  (typeof OpenWebviewActionBhActionType)[keyof typeof OpenWebviewActionBhActionType];

export const OpenWebviewActionBhActionType = {
  open_webview: 'open_webview',
} as const;
